import {mapMutations, mapGetters, mapActions} from 'vuex';
import {
  DECREMENT_AVAILABILITY_PROPS,
  INCREMENT_AVAILABILITY_PROPS,
  RESET_AVAILABILITY_PROPS,
  SET_COUNT_AVAILABILITY_PROPS
} from "@/store/mutation-types";

import {
  CHECK_AVAILABILITY_PROPS,
} from "@/store/action-types";

import _ from 'lodash';
import Moment from 'moment';
import {extendMoment} from 'moment-range';

const moment = extendMoment(Moment);

export default {
  name: 'requisite-check',
  data() {
    return {
      sundayFirst: false,
      countDatepicker: 2,
      payload: {
        to: '',
        from: '',
      }
    }
  },
  computed: {
    ...mapGetters({
      basket: `basket/basket`,
      config: 'setting/config',
      count: `requisite/count`,
      currentRequisite: `requisite/currentRequisite`,
      disabledDatesLoading: `requisite/disabledDatesLoading`,
      disabledDates: `requisite/disabledDates`,
      currentDates: `requisite/currentDates`,
    }),
    maxDate() {
      return moment(new Date()).add(1, 'Y').format('YYYY-MM-DD')
    },
    minDate() {
      return moment(new Date()).format('YYYY-MM-DD')
    },
    combineDisabledDates() {
      let disabledDatesBasket = [];
      let basketItems = [];
      let finalDisabledDates = [];

      this.basket.forEach(e => {
        if (e.id === this.currentRequisite.id) {
          basketItems.push(e);
        }
      });

      if (basketItems.length !== 0) {
        basketItems.forEach(e => {
          const dates = this.getRangeDates(e.from, e.to);
          dates.forEach(t => {
            disabledDatesBasket.push({
              date: t,
              count: e.selectCount
            });
          });
        });
      }

      let summedBasket = _(disabledDatesBasket)
        .groupBy('date')
        .map((objs, key) => {
          return {
            'date': key,
            'count': _.sumBy(objs, 'count')
          }
        })
        .value();


      summedBasket.push(...this.disabledDates);

      // let summedTotal = _(summedBasket)
      //   .groupBy('date')
      //   .map((objs, key) => {
      //     let count = 0
      //     if(objs.length > 1){
      //       count = objs[1].count - objs[0].count
      //     }else{
      //       count = objs[0].count
      //     }
      //     return {
      //       'date': objs[0].date,
      //       'count': count
      //     }
      //   })
      //   .value();
      //
      // summedTotal.forEach(e => {
      //   if (e.count < this.count) {
      //     finalDisabledDates.push(e.date);
      //   }
      // });

      let summedTotal = _(summedBasket)
        .groupBy('date')
        .map((objs, key) => {
          return {
            'date': key,
            'count': _.sumBy(objs, 'count')
          }
        })
        .value();



      summedTotal.forEach(e => {
        if((this.currentRequisite.total_count - e.count) < this.count){
          finalDisabledDates.push(e.date);
        }
      });

      return finalDisabledDates;
    },
    getInfoText() {
      let text = '';
      this.config.find(e => {
        if (e.key === 'text_check_available') {
          text = e.value;
        }
      });
      return text;
    }
  },
  created() {
    if (this.countDatepicker === 2) {
      this.payload.to = moment(new Date()).subtract(-1, 'months').endOf('month').format('YYYY-MM-DD');
      this.payload.from = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    } else {
      this.payload.from = moment(new Date()).subtract(0, 'months').startOf('month').format('YYYY-MM-DD');
      this.payload.to = moment(new Date()).subtract(0, 'months').endOf('month').format('YYYY-MM-DD');
    }

    this.debounceRequest();
  },
  mounted() {
    window.addEventListener("resize", this.resizeWindow);
    if (window.innerWidth < 851) {
      this.countDatepicker = 1
    }
  },
  methods: {
    ...mapActions({
      checkAvailability: `requisite/${CHECK_AVAILABILITY_PROPS}`
    }),
    ...mapMutations({
      increment: `requisite/${INCREMENT_AVAILABILITY_PROPS}`,
      decrement: `requisite/${DECREMENT_AVAILABILITY_PROPS}`,
      reset: `requisite/${RESET_AVAILABILITY_PROPS}`,
      setCount: `requisite/${SET_COUNT_AVAILABILITY_PROPS}`,
    }),
    resizeWindow() {
      if (window.innerWidth < 851) {
        this.countDatepicker = 1
      } else {
        this.countDatepicker = 2
      }
    },
    getRangeDates(startDate, endDate, type = 'days') {
      let
        range = moment.range(startDate, endDate),
        array = Array.from(range.by(type));

      return array.map(e => {
        return e.format("YYYY-MM-DD");
      });
    },
    changeCount(count) {
      const convertToNumber = parseInt(count);
      this.setValidValue(convertToNumber);
    },
    setValidValue: _.debounce(function (count) {
      if (count) {
        if (count > 0 && count <= this.currentRequisite.total_count) {
          this.setCount(count);
          this.debounceRequest();
        } else {
          if (parseInt(count) > this.currentRequisite.total_count) {
            this.$refs.bookingVal.$el.value = this.currentRequisite.total_count;
            this.setCount(this.currentRequisite.total_count);
            this.debounceRequest();
          }
        }
      } else {
        this.setCount(1);
        this.debounceRequest();
      }
      this.disableButton = false;
    }, 500),
    addCount() {
      this.increment();
      this.debounceRequest();
    },
    removeCount() {
      this.decrement();
      this.debounceRequest();
    },
    setDatesFromPayload(val) {
      if (this.countDatepicker === 2) {
        this.payload.from = moment(val[0]).subtract(0, 'months').startOf('month').format('YYYY-MM-DD');
        this.payload.to = moment(val[1]).subtract(0, 'months').endOf('month').format('YYYY-MM-DD');
      } else {
        this.payload.from = moment(val[0]).subtract(0, 'months').startOf('month').format('YYYY-MM-DD');
        this.payload.to = moment(val[0]).subtract(0, 'months').endOf('month').format('YYYY-MM-DD');
      }

    },
    changePreviousMounts(val) {
      this.setDatesFromPayload(val);
      this.debounceRequest();
    },
    changeNextMounts(val) {
      this.setDatesFromPayload(val);
      this.debounceRequest();
    },
    debounceRequest: _.debounce(function () {
      this.checkAvailability({
        slug: this.currentRequisite.slug,
        ...this.payload
      });
    }, 500),
  },
  destroyed() {
    this.reset();
    window.removeEventListener("resize", this.resizeWindow);
  }
}
